import React from 'react';
import {
  CustomHeadLabelRenderOptions,
  MUIDataTableColumnDef,
  MUIDataTableColumnOptions,
} from 'mui-datatables';
import {
  NumericCellHeadWrapper,
  StringCellHeadWrapper,
} from '../UI/MfResponsiveTable/MfResponsiveTable';

const stringOptions: MUIDataTableColumnOptions = {
  customHeadLabelRender: ({ label }: CustomHeadLabelRenderOptions) => (
    <StringCellHeadWrapper>{label}</StringCellHeadWrapper>
  ),
};

const numberOptions: MUIDataTableColumnOptions = {
  customHeadLabelRender: ({ label }: CustomHeadLabelRenderOptions) => (
    <NumericCellHeadWrapper>{label}</NumericCellHeadWrapper>
  ),
};

export const columns: MUIDataTableColumnDef[] = [
  {
    name: 'id',
    label: '№ заявки',
    options: stringOptions,
  },
  {
    name: 'inn',
    label: 'ИНН',
    options: stringOptions,
  },
  {
    name: 'companyName',
    label: 'Наименование',
    options: stringOptions,
  },
  {
    name: 'contactName',
    label: 'Имя контактного лица',
    options: stringOptions,
  },
  {
    name: 'contactPhone',
    label: 'Телефон контактного лица',
    options: stringOptions,
  },
  {
    name: 'amountRequested',
    label: 'Указанная сумма',
    options: numberOptions,
  },
  {
    name: 'termRequested',
    label: 'Указанный срок займа',
    options: numberOptions,
  },
  {
    name: 'offerAmountActual',
    label: 'Сумма выдачи',
    options: numberOptions,
  },
  {
    name: 'amountToPay',
    label: 'Сумма вознаграждения',
    options: numberOptions,
  },
  {
    name: 'createdAt',
    label: 'Дата создания',
    options: stringOptions,
  },
  {
    name: 'statusLabel',
    label: 'Статус',
    options: stringOptions,
  },
  {
    name: 'reasonRefusal',
    label: 'Причина отказа',
    options: stringOptions,
  },
  {
    name: 'actions',
    label: ' ',
    options: stringOptions,
  },
];
